import jQuery from "jquery";
import { loader } from "./LoaderBridge";

export default function setupAjax() {
    if (typeof window !== "undefined") {
        const $ = jQuery; // directly assign

        if ($ && $.ajaxSetup) {
            $.ajaxSetup({
                beforeSend: function () {
                    loader.start();
                },
                complete: function () {
                    loader.stop();
                },
                error: function () {
                    loader.stop();
                }
            });
        } else {
            console.warn("jQuery or $.ajaxSetup not available");
        }
    }
}